var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"mb__popup-action CartListBtn",attrs:{"status":_vm.isCartOpen ? 'open' : ''},on:{"click":_vm.handleClickCartIcon}},[_c('span',{staticClass:"Quantity"},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }